import React from 'react'
import PropTypes from 'prop-types'
import ReactCSSTransitionReplace from 'react-css-transition-replace'
import PasswordResetSendEmailForm from './PasswordResetSendEmailForm.js'
import PasswordResetCodeValidator from './PasswordResetCodeValidator.js'
import PasswordResetChangePasswordForm from './PasswordResetChangePasswordForm.js'
import MultiMessageError from '../../../MultiMessageError.js'
import ErrorList from './ErrorList.js'

export default class PasswordResetWizard extends React.Component {
  static get propTypes () {
    return {
      member: PropTypes.instanceOf(Foundation.Member).isRequired,
      isMobile: PropTypes.bool.isRequired,
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      email: this.props.member.get('email'),
      code: null,
      userHasCode: false,
      codeIsValid: false,
      passwordWasReset: false,
      error: null,
    }
  }

  willUnmount () {
    this.props.member.set('email', this.state.email)
  }

  render () {
    let view
    if (this.state.passwordWasReset) {
      view = (
        <div>
          <p><b>Logging in as {this.state.email}…</b></p>
          <ErrorList error={this.state.error} />
        </div>
      )
    }
    else if (this.state.codeIsValid) {
      view = <PasswordResetChangePasswordForm
        key='change-password'
        email={this.state.email}
        code={this.state.code}
        onCompletion={data => this.passwordWasReset(data)}
        isMobile={this.props.isMobile}
      />
    }
    else if (this.state.userHasCode) {
      view = <PasswordResetCodeValidator
        key='code-validator'
        email={this.state.email}
        onCompletion={code => this.codeIsValid(code)}
        onCancel={() => this.setState({ userHasCode: false })}
        isMobile={this.props.isMobile}
      />
    }
    else {
      view = <PasswordResetSendEmailForm
        key='send-email'
        email={this.state.email}
        onCompletion={email => this.codeWasSent(email)}
        isMobile={this.props.isMobile}
      />
    }

    const fadeDurationMS = 500

    return (
      <div>
        <style>{`
          .password-reset-wizard-form-enter {
            opacity: 0.01;
          }
          .password-reset-wizard-form-enter-active {
            opacity: 1;
            transition: opacity ${fadeDurationMS}ms ease-in;
          }
          .password-reset-wizard-form-leave {
            opacity: 1;
          }
          .password-reset-wizard-form-leave-active {
            opacity: 0.01;
            transition: opacity ${fadeDurationMS}ms ease-out;
          }
          .password-reset-wizard-form-height {
            transition: height ${fadeDurationMS}ms ease-in-out
          }
        `}</style>

        <ReactCSSTransitionReplace
          transitionName='password-reset-wizard-form'
          transitionEnterTimeout={fadeDurationMS}
          transitionLeaveTimeout={fadeDurationMS}
        >
          {view}
        </ReactCSSTransitionReplace>
      </div>
    )
  }

  codeWasSent (email) {
    this.setState({ email, userHasCode: true })
  }

  codeIsValid (code) {
    this.setState({ code, codeIsValid: true })
  }

  passwordWasReset (data) {
    const {email, password} = data

    this.props.member.set('email', email)
    this.setState({ passwordWasReset: true })

    setTimeout(() => {
      const attempt = new Foundation.Login.Attempt(this.props.member)
      attempt.forEmail(email)
      attempt.withPassword(password)
      const result = attempt.performAttempt()
        .otherwise(() => {
          this.setState({ error: new MultiMessageError(result.errors()) })
        })
    }, 1500)
  }
}
